<div class="row" [formGroup]="formGroup">
    <div class="col-7">
        <div class="float-end">
            <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteBannerLocale()" *ngIf="!deleteBannerLocaleVisible">
                <i class="fas fa-times"></i> Remove
            </button>
            <button class="btn btn-sm btn-danger" (click)="deleteBannerLocale()" *ngIf="deleteBannerLocaleVisible">
                <i class="fas fa-exclamation-circle"></i> Confirm
            </button>
        </div>
        <div class="mb-3">
            <label for="bannerLinkInput_{{ banner.id }}_{{ formGroup.value.bannerLocaleLocaleInput }}">Link (Locale "{{ formGroup.value.bannerLocaleLocaleInput }}")</label>
            <input type="text" class="form-control" id="bannerLinkInput_{{ banner.id }}_{{ formGroup.value.bannerLocaleLocaleInput }}" formControlName="bannerLocaleLinkInput" placeholder="https://www.mykronoz.com, https://www.facebook.com/mykronoz, ...">
        </div>
    </div>
    <div class="col-5">
        <a href="{{ formGroup.value.bannerLocaleLinkInput }}">
            <span class="d-block text-truncate">
                <i class="fas fa-external-link-alt"></i> {{ formGroup.value.bannerLocaleLinkInput }}
            </span>
            <img class="img-fluid w-100" src="{{ formGroup.value.bannerLocaleUrlInput }}">
        </a>
    </div>
</div>